module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/border-right.a1c7a9b8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/border-right.png
// module id = 2747
// module chunks = 11